export enum DashboardType {
    Dashboard = 'dashboard',
    Favorites = 'favorites',
    PortfolioFavorites = 'portfolio',
    Report = 'report',
}
